@if (widgetWrapper.showProperties) {
  <div class="general-container">
    <div class="text-black text-xs">
      <div >
        {{'widgets.common.include' | translate}}:
        <img src ="assets/icons/icon_info.png" width="15px" height="15px" alt="info"
          pTooltip="{{'widgets.common.tooltip' | translate}}"><br>
          <div>
            @for (entity of filterSettings.fiterEntities; track entity) {
              <label class="w-10rem">
                <input type="checkbox" value="{{entity.id}}"
                  [(ngModel)]="entity.checked"/> {{entity.name}}
                </label>
              }
            </div>
          </div>
        </div>
        <div class="text-center mt-2 mb-3">
          <p-button styleClass="p-button-sm p-0" label="{{'widgets.common.applySettings' | translate}}" (click)="saveSettings()"></p-button>
        </div>
      </div>
    }
    <div>
      <p class="text-xs font-bold">{{'widgets.quickAccess.subtitle' | translate}}:</p>
    </div>

    <div class="w-10 mb-3" >
      @if (visibleEntities.includes(entityName.COMPANY)) {
        <div class="w-full flex flex-row justify-content-end">
          <div class="w-5 text-right">
            <span class="text-xs pl-2">{{'widgets.quickAccess.company' | translate}}:</span>
          </div>
          <div class="w-6">
            <input type="text" #inputCompanyId [(ngModel)]="companyID"
              [attr.aria-label]="'widgets.quickAccess.company' | translate"
              class="w-full ml-1 border-1 h-1rem text-xs"
              maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToCompany()" (paste)="goToCompany($event)">
            </div>
            <div class="w-1">
              <button (click)="goToCompany()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.company' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
            </div>
          </div>
        }
        @if (visibleEntities.includes(entityName.SITE)) {
          <div class="w-full flex flex-row justify-content-end">
            <div class="w-5 text-right">
              <span class="text-xs pl-2">{{'widgets.quickAccess.site' | translate}}:</span>
            </div>
            <div class="w-6">
              <input type="text" #inputSiteId [(ngModel)]="siteID"
                [attr.aria-label]="'widgets.quickAccess.site' | translate"
                class="w-full ml-1 border-1 h-1rem text-xs"
                maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToSite()" (paste)="goToSite($event)">
              </div>
              <div class="w-1">
                <button (click)="goToSite()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.site' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
              </div>
            </div>
          }
          @if (visibleEntities.includes(entityName.ASSET_PIPELINE)) {
            <div class="w-full flex flex-row justify-content-end">
              <div class="w-5 text-right">
                <span class="text-xs pl-2">{{'widgets.quickAccess.pipeline' | translate}}:</span>
              </div>
              <div class="w-6">
                <input type="text" #inputPipelineId [(ngModel)]="pipelineID"
                  [attr.aria-label]="'widgets.quickAccess.pipeline' | translate"
                  class="w-full ml-1 border-1 h-1rem text-xs"
                  maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToPipeline()" (paste)="goToPipeline($event)">
                </div>
                <div class="w-1">
                  <button (click)="goToPipeline()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.pipeline' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                </div>
              </div>
            }
            @if (visibleEntities.includes(entityName.ASSET_TRANSMISSION_LINE)) {
              <div class="w-full flex flex-row justify-content-end">
                <div class="w-5 text-right">
                  <span class="text-xs pl-2">{{'widgets.quickAccess.tLine' | translate}}:</span>
                </div>
                <div class="w-6">
                  <input type="text" #inputTlineId [(ngModel)]="tLineID"
                    [attr.aria-label]="'widgets.quickAccess.tLine' | translate"
                    class="w-full ml-1 border-1 h-1rem text-xs"
                    maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToTLine()" (paste)="goToTLine($event)">
                  </div>
                  <div class="w-1">
                    <button (click)="goToTLine()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.tLine' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                  </div>
                </div>
              }
              @if (visibleEntities.includes(entityName.PLANT)) {
                <div class="w-full flex flex-row justify-content-end">
                  <div class="w-5 text-right">
                    <span class="text-xs pl-2">{{'widgets.quickAccess.plant' | translate}}:</span>
                  </div>
                  <div class="w-6">
                    <input type="text" #inputPlantId [(ngModel)]="plantID"
                      [attr.aria-label]="'widgets.quickAccess.plant' | translate"
                      class="w-full ml-1 border-1 h-1rem text-xs"
                      maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToPlant()" (paste)="goToPlant($event)">
                    </div>
                    <div class="w-1">
                      <button (click)="goToPlant()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.plant' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                    </div>
                  </div>
                }

                @if (visibleEntities.includes(entityName.AREA)) {
                  <div class="w-full flex flex-row justify-content-end">
                    <div class="w-5 text-right">
                      <span class="text-xs pl-2">{{'widgets.quickAccess.area' | translate}}:</span>
                    </div>
                    <div class="w-6">
                      <input type="text" #inputAreaId [(ngModel)]="areaID"
                        [attr.aria-label]="'widgets.quickAccess.area' | translate"
                        class="w-full ml-1 border-1 h-1rem text-xs"
                        maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToArea()" (paste)="goToArea($event)">
                      </div>
                      <div class="w-1">
                        <button (click)="goToArea()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.area' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                      </div>
                    </div>
                  }

                  @if (visibleEntities.includes(entityName.UNIT)) {
                    <div class="w-full flex flex-row justify-content-end">
                      <div class="w-5 text-right">
                        <span class="text-xs pl-2">{{'widgets.quickAccess.unit' | translate}}:</span>
                      </div>
                      <div class="w-6">
                        <input type="text" #inputUnitId [(ngModel)]="unitID"
                          [attr.aria-label]="'widgets.quickAccess.unit' | translate"
                          class="w-full ml-1 border-1 h-1rem text-xs"
                          maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToUnit()" (paste)="goToUnit($event)">
                        </div>
                        <div class="w-1">
                          <button (click)="goToUnit()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.unit' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                        </div>
                      </div>
                    }

                    @if (visibleEntities.includes(entityName.PROJECT_CONFIRMED)) {
                      <div class="w-full flex flex-row justify-content-end">
                        <div class="w-5 text-right">
                          <span class="text-xs pl-2">{{'widgets.quickAccess.confirmedProject' | translate}}:</span>
                        </div>
                        <div class="w-6">
                          <input type="text" #inputConfirmedProjectId [(ngModel)]="confirmedProjectID"
                            [attr.aria-label]="'widgets.quickAccess.confirmedProject' | translate"
                            class="w-full ml-1 border-1 h-1rem text-xs"
                            maxlength="15" (input)="cleanID($event)" (keyup.enter)="goToConfirmedProject()" (paste)="goToConfirmedProject($event)">
                          </div>
                          <div class="w-1">
                            <button (click)="goToConfirmedProject()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.confirmedProject' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                          </div>
                        </div>
                      }

                      @if (visibleEntities.includes(entityName.PROJECT_UNCONFIRMED)) {
                        <div class="w-full flex flex-row justify-content-end">
                          <div class="w-5 text-right">
                            <span class="text-xs pl-2">{{'widgets.quickAccess.unconfirmedProject' | translate}}:</span>
                          </div>
                          <div class="w-6">
                            <input type="text" #inputUnconfirmedProjectId [(ngModel)]="unconfirmedProjectID"
                              [attr.aria-label]="'widgets.quickAccess.unconfirmedProject' | translate"
                              class="w-full ml-1 border-1 h-1rem text-xs"
                              maxlength="15" (input)="cleanID($event)" (keyup.enter)="goToUnconfirmedProject()" (paste)="goToUnconfirmedProject($event)">
                            </div>
                            <div class="w-1">
                              <button (click)="goToUnconfirmedProject()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.unconfirmedProject' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                            </div>
                          </div>
                        }

                        @if (visibleEntities.includes(entityName.BOILER)) {
                          <div class="w-full flex flex-row justify-content-end">
                            <div class="w-5 text-right">
                              <span class="text-xs pl-2">{{'widgets.quickAccess.boiler' | translate}}:</span>
                            </div>
                            <div class="w-6">
                              <input type="text" #inputBoilerId [(ngModel)]="boilerID"
                                [attr.aria-label]="'widgets.quickAccess.boiler' | translate"
                                class="w-full ml-1 border-1 h-1rem text-xs"
                                maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToBoiler()" (paste)="goToBoiler($event)">
                              </div>
                              <div class="w-1">
                                <button (click)="goToBoiler()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.boiler' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                              </div>
                            </div>
                          }

                          @if (visibleEntities.includes(entityName.TURBINE)) {
                            <div class="w-full flex flex-row justify-content-end">
                              <div class="w-5 text-right">
                                <span class="text-xs pl-2">{{'widgets.quickAccess.drive' | translate}}:</span>
                              </div>
                              <div class="w-6">
                                <input type="text" #inputDriveId [(ngModel)]="driveID"
                                  [attr.aria-label]="'widgets.quickAccess.drive' | translate"
                                  class="w-full ml-1 border-1 h-1rem text-xs"
                                  maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToDrive()" (paste)="goToDrive($event)">
                                </div>
                                <div class="w-1">
                                  <button (click)="goToDrive()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.drive' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                </div>
                              </div>
                            }

                            @if (visibleEntities.includes(entityName.TANK)) {
                              <div class="w-full flex flex-row justify-content-end">
                                <div class="w-5 text-right">
                                  <span class="text-xs pl-2">{{'widgets.quickAccess.tank' | translate}}:</span>
                                </div>
                                <div class="w-6">
                                  <input type="text" #inputTankId [(ngModel)]="tankID"
                                    [attr.aria-label]="'widgets.quickAccess.tank' | translate"
                                    class="w-full ml-1 border-1 h-1rem text-xs"
                                    maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToTank()" (paste)="goToTank($event)">
                                  </div>
                                  <div class="w-1">
                                    <button (click)="goToTank()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.tank' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                  </div>
                                </div>
                              }

                              @if (visibleEntities.includes(entityName.MEQUIPMENT)) {
                                <div class="w-full flex flex-row justify-content-end">
                                  <div class="w-5 text-right">
                                    <span class="text-xs pl-2">{{'widgets.quickAccess.miningEquipment' | translate}}:</span>
                                  </div>
                                  <div class="w-6">
                                    <input type="text" #inputMEquipmentId [(ngModel)]="mEquipmentID"
                                      [attr.aria-label]="'widgets.quickAccess.miningEquipment' | translate"
                                      class="w-full ml-1 border-1 h-1rem text-xs"
                                      maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToMEquipment()" (paste)="goToMEquipment($event)">
                                    </div>
                                    <div class="w-1">
                                      <button (click)="goToMEquipment()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.miningEquipment' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                    </div>
                                  </div>
                                }

                                @if (visibleEntities.includes(entityName.OEQUIPMENT)) {
                                  <div class="w-full flex flex-row justify-content-end">
                                    <div class="w-5 text-right">
                                      <span class="text-xs pl-2">{{'widgets.quickAccess.equipment' | translate}}:</span>
                                    </div>
                                    <div class="w-6">
                                      <input type="text" #inputEquipmentId [(ngModel)]="equipmentID"
                                        [attr.aria-label]="'widgets.quickAccess.equipment' | translate"
                                        class="w-full ml-1 border-1 h-1rem text-xs"
                                        maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToEquipment()" (paste)="goToEquipment($event)">
                                      </div>
                                      <div class="w-1">
                                        <button (click)="goToEquipment()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.equipment' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                      </div>
                                    </div>
                                  }

                                  @if (visibleEntities.includes(entityName.OFFLINE_EVENT)) {
                                    <div class="w-full flex flex-row justify-content-end">
                                      <div class="w-5 text-right">
                                        <span class="text-xs pl-2">{{'widgets.quickAccess.offlineEvent' | translate}}:</span>
                                      </div>
                                      <div class="w-6">
                                        <input type="text" #inputOfflineEventId [(ngModel)]="offlineEventID"
                                          [attr.aria-label]="'widgets.quickAccess.offlineEvent' | translate"
                                          class="w-full ml-1 border-1 h-1rem text-xs"
                                          maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToOfflineEvent()" (paste)="goToOfflineEvent($event)">
                                        </div>
                                        <div class="w-1">
                                          <button (click)="goToOfflineEvent()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.offlineEvent' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                        </div>
                                      </div>
                                    }

                                    @if (visibleEntities.includes(entityName.PLANT_LTSA)) {
                                      <div class="w-full flex flex-row justify-content-end">
                                        <div class="w-5 text-right">
                                          <span class="text-xs pl-2">{{'widgets.quickAccess.plantLtsa' | translate}}:</span>
                                        </div>
                                        <div class="w-6">
                                          <input type="text" #inputPlantLtsaId [(ngModel)]="plantLtsaID"
                                            [attr.aria-label]="'widgets.quickAccess.plantLtsa' | translate"
                                            class="w-full ml-1 border-1 h-1rem text-xs"
                                            maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToPlantLtsa()" (paste)="goToPlantLtsa($event)">
                                          </div>
                                          <div class="w-1">
                                            <button (click)="goToPlantLtsa()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.plantLtsa' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                          </div>
                                        </div>
                                      }

                                      @if (visibleEntities.includes(entityName.UNIT_LTSA)) {
                                        <div class="w-full flex flex-row justify-content-end">
                                          <div class="w-5 text-right">
                                            <span class="text-xs pl-2">{{'widgets.quickAccess.unitLtsa' | translate}}:</span>
                                          </div>
                                          <div class="w-6">
                                            <input type="text" #inputUnitLtsaId [(ngModel)]="unitLtsaID"
                                              [attr.aria-label]="'widgets.quickAccess.unitLtsa' | translate"
                                              class="w-full ml-1 border-1 h-1rem text-xs"
                                              maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToUnitLtsa()" (paste)="goToUnitLtsa($event)">
                                            </div>
                                            <div class="w-1">
                                              <button (click)="goToUnitLtsa()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.unitLtsa' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                            </div>
                                          </div>
                                        }

                                        @if (visibleEntities.includes(entityName.PIPELINE_LTSA)) {
                                          <div class="w-full flex flex-row justify-content-end">
                                            <div class="w-5 text-right">
                                              <span class="text-xs pl-2">{{'widgets.quickAccess.pipelineLtsa' | translate}}:</span>
                                            </div>
                                            <div class="w-6">
                                              <input type="text" #inputPipelineLtsaId [(ngModel)]="pipelineLtsaID"
                                                [attr.aria-label]="'widgets.quickAccess.pipelineLtsa' | translate"
                                                class="w-full ml-1 border-1 h-1rem text-xs"
                                                maxlength="7" (input)="cleanID($event)" (keyup.enter)="goToPipelineLtsa()" (paste)="goToPipelineLtsa($event)">
                                              </div>
                                              <div class="w-1">
                                                <button (click)="goToPipelineLtsa()" [attr.aria-label]="('widgets.quickAccess.go' | translate) + ' ' + ('widgets.quickAccess.pipelineLtsa' | translate)" class="btn-custom">{{'widgets.quickAccess.go' | translate}}!</button>
                                              </div>
                                            </div>
                                          }

                                        </div>
